<template>
  <div class="app-container">
    <el-form :model="queryParams" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="文件名" prop="fileName">
        <el-input
            v-model="queryParams.fileName"
            placeholder="请输入文件名"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="报告日期" prop="reportDate">
        <el-date-picker clearable size="small"
                        v-model="queryParams.reportDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择报告日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="创建日期" prop="createdDate">
        <el-date-picker clearable size="small"
                        v-model="queryParams.createdDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择创建日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table style="width: 75%" v-loading="loading" :data="reportList">
      <el-table-column label="id" align="center" prop="id"/>
      <el-table-column label="文件名" align="center" prop="fileName"/>
      <el-table-column label="文件地址" align="center" prop="url">
        <template slot-scope="scope">
          <a :href="scope.row.url"  target="_blank" >{{scope.row.url}}</a>
        </template>
      </el-table-column>
      <el-table-column label="报告日期" align="center" prop="reportDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.reportDate, '{y}-{m}-{d}') }}</span>
<!--          {{ scope.row.reportDate }}-->
        </template>
      </el-table-column>
      <el-table-column label="创建日期" align="center" prop="createdDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createdDate, '{y}-{m}-{d}') }}</span>
<!--          {{ scope.row.createdDate }}-->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {listReport} from "@/api/report";

export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      // 导出遮罩层
      exportLoading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 【请填写功能名称】表格数据
      reportList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        // pageNum: 1,
        // pageSize: 10,
        fileName: null,
        reportDate: null,
        updatedTime: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    parseTime(time, pattern) {
      if (arguments.length === 0 || !time) {
        return null
      }
      const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
          time = parseInt(time)
        } else if (typeof time === 'string') {
          time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
          time = time * 1000
        }
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    },
    /** 查询【请填写功能名称】列表 */
    getList() {
      this.loading = true;
      listReport(this.queryParams).then(response => {
        console.log(response)
        this.reportList = response.data.data;
        // this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    //重置搜索条件
    resetSearch() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        fileName: null,
        url: null,
        reportType: null,
        reportDate: null,
        status: null,
        isDel: null,
        createdBy: null,
        createdDate: null,
        updatedBy: null,
        updatedTime: null
      }
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        fileName: null,
        url: null,
        reportType: null,
        reportDate: null,
        status: 0,
        isDel: null,
        createdBy: null,
        createdDate: null,
        updatedBy: null,
        updatedTime: null
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetSearch();
      this.handleQuery();
    },
  }
};
</script>